import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	issuesTableLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issuesTableLabelIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	issuesTableLabel: {
		id: 'native-issue-table.issue-table.issues-table-label',
		defaultMessage: 'Issues',
		description: 'Name of table for screen reader users',
	},
	issuesTableLabelIssueTermRefresh: {
		id: 'native-issue-table.issue-table.issues-table-label-issue-term-refresh',
		defaultMessage: 'Work',
		description: 'Name of table for screen reader users',
	},
});
export default messages;
